import { get } from '~shared/utils/http';
import { isUserLoggedIn, onUserModeChange } from '~shared/utils/user';
import { buildSpectateUrl } from './Spectate';
import { getHeartbeatConfig } from './SiteConfig';

let hbInterval = null;

const missesCounter = {
    max: 3,
    counter: 0,
    reset() {
        this.counter = 0;
    },
    increment() {
        this.counter++;

        return this;
    },
    onMaxMissesReached(callback) {
        if (this.counter >= this.max) {
            callback();
        }
    },
};

const handleBeatError = () => missesCounter.increment().onMaxMissesReached(
    stopHeartbeat
);

const handleBeatSuccess = () => missesCounter.reset();

const beat = async () => {
    let response;
    try {
        response = await get(buildSpectateUrl('/heart/beat'));
    } catch (e) {
        handleBeatError();

        return;
    }

    if (!response.ok) {
        handleBeatError();
    } else {
        handleBeatSuccess();
    }
};

const runHeartbeat = () => {
    const { interval } = getHeartbeatConfig();
    const delay = interval * 1000;

    hbInterval = setInterval(() => {
        beat();
    }, delay);
};

const stopHeartbeat = () => clearInterval(hbInterval);

const hbManager = (isAnonymous) => {
    return !isAnonymous
        ? runHeartbeat()
        : stopHeartbeat();
};

const initHeartBeat = () => {
    const { enabled } = getHeartbeatConfig();

    if (!enabled) {
        return;
    }

    hbManager(isUserLoggedIn());

    onUserModeChange((_, isLoggedIn) => hbManager(isLoggedIn));
};

export { initHeartBeat };
